import React, { useState, useCallback } from 'react'
import {
  Box,
  Text,
  IcoMoon,
  GridViewIcon,
  ListViewIcon,
} from '@usap/uicomponents'
import styled from 'styled-components'
import { BoxWithPointer } from './StyledCSS'

const Container = styled(Box)`
  padding-right: ${props => props.theme.global.edgeSize.medium}
`

const ToggleContainer = styled(Box)`
  margin-right: 0px;
  font-size: ${props => props.theme.global.text.small.size};
  line-height: ${props => props.theme.global.text.small.height};

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    margin-right: 10px;
  }
`

const ToggleText = styled(Text)`
  margin-left: ${props => props.theme.global.edgeSize.xsmall}
`

export default function ToggleView({ listView, toggleListView }) {
  const [selected, toggleSelected] = useState(listView)
  const toggle = useCallback(() => {
    toggleListView(!listView)
    toggleSelected(!listView)
  }, [listView, toggleListView])

  return (
    <Container
      direction="row"
      wrap
      align="end"
      gap="small"
    >
      <BoxWithPointer
        id="toggleToGrid"
        onClick={toggle}
      >
        <ToggleContainer
          direction="row"
          align="center"
        >
          <IcoMoon
            icon={GridViewIcon}
            color={selected ? 'dark-1' : 'brand'}
            size="24px"
          />
          <ToggleText
            size="small"
            color={selected ? 'dark-1' : 'brand'}
            textAlign="center"
            as={selected ? 'normal' : 'strong'}
          >
            Grid View
          </ToggleText>
        </ToggleContainer>
      </BoxWithPointer>

      <BoxWithPointer
        id="toggleToList"
        onClick={toggle}
      >
        <ToggleContainer
          direction="row"
          align="center"
        >
          <IcoMoon
            icon={ListViewIcon}
            color={selected ? 'brand' : 'dark-1'}
            size="24px"
          />
          <ToggleText
            size="small"
            color={selected ? 'brand' : 'dark-1'}
            textAlign="center"
            as={selected ? 'strong' : 'normal'}
          >
            List View
          </ToggleText>
        </ToggleContainer>
      </BoxWithPointer>
    </Container>
  )
}
